import React from 'react';
import MicroAppData from '@/components/micro-app-data';

export default function DataPanel() {
  return <MicroAppData pageId="920" />;
}
